export enum CommandToBeSendStatus {
	PENDING = 'PENDING',
	WAITINGFORACK = 'WAITINGFORACK',
	ACKNOWLEDGED = 'ACKNOWLEDGED',
	COMPLETED = 'COMPLETED',
}
